import React, { Component } from 'react';
import { SimpleForm, NumberInput, TextInput, Toolbar, SaveButton, ReferenceInput, SelectInput, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import SearchableSelectInput from '~components/SearchableSelectInput';
import { isRequired } from '~utils/inputValidations';

function MetricValueToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class MetricValueForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<MetricValueToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.metricValue">
          <ReferenceInput source="metric" reference="metrics" validate={isRequired} sort={{ field: 'name', order: 'ASC' }} perPage={200}>
            <SearchableSelectInput placeholder="Métrica" />
          </ReferenceInput>
          <ReferenceInput source="pais" reference="countries" allowEmpty>
            <SelectInput optionText="name" />
          </ReferenceInput>
          <ReferenceInput source="etapa" reference="etapas" allowEmpty>
            <SelectInput optionText="name" />
          </ReferenceInput>
          <ReferenceInput source="subtema" reference="subthemes" allowEmpty>
            <SelectInput optionText="name" />
          </ReferenceInput>
          <NumberInput source="value" validate={isRequired} />
          <TextInput source="detalle" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(MetricValueForm);
